import React from "react";
import style from "./Card.module.css";
import { FaUserDoctor } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import { LuArchiveRestore } from "react-icons/lu";
const Card = ({
  fast,
  cheap,
  isLoading,
  onAccept,
  onRequestPriceUpdate,
  acceptingBidId,
  requestingBidId,
  requestedBidIds,
  hasZeroPriceItems,
}) => {
  if (isLoading) {
    return (
      <section className={style.recommendationSection}>
        <div className={style.headerRow}>
          <p className={style.title}>System Recommendation</p>
        </div>

        <div className={style.card}>
          {["Lowest Bids", "Closest Bids"].map((label, index) => (
            <div
              key={label}
              className={style.cardItem}
              style={{ animationDelay: `${80 + index * 100}ms` }}
            >
              <p className={style.bid}>{label}</p>
              <div className={style.background}>
                <div className={style.contentWrap}>
                  {[0, 1, 2].map((row) => (
                    <div key={row} className={style.detail}>
                      <div className={`${style.skeletonCircle} ${style.skeletonShimmer}`}></div>
                      <div
                        className={`${style.skeletonLine} ${style.skeletonShimmer}`}
                        style={{ width: row === 1 ? "52%" : "70%" }}
                      ></div>
                    </div>
                  ))}

                  <div className={style.btn}>
                    <div className={style.actionButtons}>
                      <div className={`${style.skeletonBtn} ${style.skeletonShimmer}`}></div>
                      <div className={`${style.skeletonBtnWide} ${style.skeletonShimmer}`}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className={style.recommendationSection}>
      <div className={style.headerRow}>
        <p className={style.title}>System Recommendation</p>
      </div>

      <div className={style.card}>
        <div className={style.cardItem} style={{ animationDelay: "80ms" }}>
          <p className={style.bid}>Lowest Bids</p>
          <div className={style.background}>
            {cheap ? (
              // cheap.map((cheap, index) => (
              <div className={style.contentWrap}>
                <div className={style.detail}>
                  <div className={style.icon}>
                    <FaUserDoctor />
                  </div>
                  <p>Vendor name: {cheap.name}</p>
                </div>

                <div className={style.detail}>
                  <div className={style.icon}>
                    <GiReceiveMoney />
                  </div>
                  <p>Total cost: {cheap.cost_rating}</p>
                </div>

                <div className={style.detail}>
                  <div className={style.icon}>
                    <LuArchiveRestore />
                  </div>
                  <p>Items:</p>
                </div>

                <div className={style.btn}>
                  <div className={style.actionButtons}>
                    <button
                      className={`${style.button} ${acceptingBidId === cheap?.id ? style.disabledButton : ""}`}
                      onClick={() => onAccept(cheap)}
                      disabled={acceptingBidId === cheap?.id}
                    >
                      {acceptingBidId === cheap?.id ? "Accepting..." : "Accept"}
                    </button>
                    {hasZeroPriceItems(cheap) && (
                      <button
                        className={`${style.warningButton} ${requestedBidIds[cheap?.id] ? style.requestedButton : ""} ${requestingBidId === cheap?.id ? style.disabledButton : ""}`}
                        onClick={() => onRequestPriceUpdate(cheap)}
                        disabled={requestingBidId === cheap?.id || requestedBidIds[cheap?.id]}
                      >
                        {requestingBidId === cheap?.id
                          ? "Requesting..."
                          : requestedBidIds[cheap?.id]
                            ? "Requested"
                            : "Request Price Update"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              // ))
              <div className="d-flex justify-content-center align-items-center">No cheapest Bid For Now!</div>
            )}
          </div>
        </div>

        <div className={style.cardItem} style={{ animationDelay: "180ms" }}>
          <p className={style.bid}>Closest Bids</p>
          <div className={style.background}>
            {fast ? (
              // fast?.map((fast, index) => (
              <div className={style.contentWrap}>
                <div className={style.detail}>
                  <div className={style.icon}>
                    <FaUserDoctor />
                  </div>
                  <p>Vendor name: {fast.name}</p>
                </div>

                <div className={style.detail}>
                  <div className={style.icon}>
                    <GiReceiveMoney />
                  </div>
                  <p>Total cost: {fast.cost_rating}</p>
                </div>

                <div className={style.detail}>
                  <div className={style.icon}>
                    <LuArchiveRestore />
                  </div>
                  <p>Items:</p>
                </div>

                <div className={style.btn}>
                  <div className={style.actionButtons}>
                    <button
                      className={`${style.button} ${acceptingBidId === fast?.id ? style.disabledButton : ""}`}
                      onClick={() => onAccept(fast)}
                      disabled={acceptingBidId === fast?.id}
                    >
                      {acceptingBidId === fast?.id ? "Accepting..." : "Accept"}
                    </button>
                    {hasZeroPriceItems(fast) && (
                      <button
                        className={`${style.warningButton} ${requestedBidIds[fast?.id] ? style.requestedButton : ""} ${requestingBidId === fast?.id ? style.disabledButton : ""}`}
                        onClick={() => onRequestPriceUpdate(fast)}
                        disabled={requestingBidId === fast?.id || requestedBidIds[fast?.id]}
                      >
                        {requestingBidId === fast?.id
                          ? "Requesting..."
                          : requestedBidIds[fast?.id]
                            ? "Requested"
                            : "Request Price Update"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              // ))
              <div className="d-flex justify-content-center align-items-center">No Fatest Bid For Now!</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Card;
